var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"md-layout-item md-size-50 md-small-size-100"},[_c('md-button',{staticClass:"md-layout-item md-size-95 md-raised",class:{
      'md-size-95': !_vm.primary,
      'md-size-100': _vm.primary,
      'md-primary': _vm.primary
    },staticStyle:{"font-size":"3em","height":"1.5em"},style:(_vm.extraStyle),attrs:{"disabled":_vm.disabled,"to":_vm.to},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }